/**
 * Enum Trạng thái biên lai
 * ndquang1 27.04.2023
 */
export default {
  // / Tất cả
  All: -1,
  // / Biên lai gốc
  ReceiptOrigin: 0,
  // / Biên lai xóa bỏ
  ReceiptDeleted: 1,
};
